module.exports = __webpack_public_path__ + "img/plat_4879.e2b0a12a.jpg";